import renderCollectionFeaturedItemCard from '../actions/renderCollectionFeaturedItemCard';

/**
 * Featured Collection Items block
 */
const FeaturedCollectionItems =( $ )=>{

	if ( $( 'body' ).hasClass( 'collection-template-default' ) ) {
		renderCollectionFeaturedItemCard();
	}

};

export default FeaturedCollectionItems;
